import { format, parse } from 'date-fns';

export const formatApiParamDate = (value: Date) => format(value, 'yyyyMMdd');

export const parseApiParamDate = (value: string) => parse(value, 'yyyyMMdd', new Date());
